import React from 'react';
import reducer from './reducer';

const initial = {
 items: null, totalItems: null, amount: null, isOpened: false,
};
export const CartContext = React.createContext({});

const CartData = ({ children }) => {
    const [state, dispatch] = React.useReducer(reducer, initial);

    return <CartContext.Provider value={[state, dispatch]}>{children}</CartContext.Provider>;
};

export default CartData;
